import PropTypes from 'prop-types';

export const OptionsProp = PropTypes.shape({
	description: PropTypes.string.isRequired,
	key: PropTypes.number.isRequired
});

export const FeatureProp = PropTypes.shape({
	packageName: PropTypes.string.isRequired,
	key: PropTypes.number.isRequired,
	options: PropTypes.arrayOf(OptionsProp)
});
